import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock3Icon } from 'lucide-react';
function getInitialTarget(): number {
  const stored = window.localStorage.getItem('ballet_teacher_ready_countdown');
  const parsed = stored ? Number.parseInt(stored, 10) : 0;
  if (parsed > Date.now()) return parsed;
  const target = Date.now() + 24 * 60 * 60 * 1000;
  window.localStorage.setItem('ballet_teacher_ready_countdown', String(target));
  return target;
}
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function CountdownTimer() {
  const [remaining, setRemaining] = useState(24 * 60 * 60 * 1000);
  useEffect(() => {
    let target = getInitialTarget();
    const tick = () => {
      if (target <= Date.now()) target = getInitialTarget();
      setRemaining(Math.max(0, target - Date.now()));
    };
    tick();
    const timer = window.setInterval(tick, 1000);
    return () => window.clearInterval(timer);
  }, []);
  const hours = Math.floor(remaining / 3600000);
  const minutes = Math.floor(remaining % 3600000 / 60000);
  const seconds = Math.floor(remaining % 60000 / 1000);
  return <motion.div initial={{
    opacity: 0,
    y: 14
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} className="mx-auto mt-12 max-w-3xl rounded-2xl border border-ballet-gold/55 bg-white p-6 text-center shadow-card sm:p-8" data-id="element-48">
      <div className="flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-[0.12em] text-ballet-rose" data-id="element-49">
        <Clock3Icon size={18} data-id="element-50" /> The launch price ends in
      </div>
      <div className="mt-6 flex items-center justify-center gap-2 sm:gap-4" data-id="element-51">
        <TimeBox value={pad(hours)} label="hrs" data-id="element-52" />
        <span className="text-2xl text-ballet-gold" data-id="element-53">:</span>
        <TimeBox value={pad(minutes)} label="min" data-id="element-54" />
        <span className="text-2xl text-ballet-gold" data-id="element-55">:</span>
        <TimeBox value={pad(seconds)} label="sec" data-id="element-56" />
      </div>
      <p className="mt-6 text-sm font-semibold uppercase tracking-[0.08em] text-ballet-ink" data-id="element-57">
        After this, the price increases and will not come back down.
      </p>
      <div className="mt-6 text-left" data-id="element-58">
        <div className="mb-2 flex justify-between text-xs font-bold uppercase tracking-wide text-ballet-muted" data-id="element-59">
          <span data-id="element-60">Launch price spots remaining</span>
          <span className="text-ballet-rose" data-id="element-61">Only a few left</span>
        </div>
        <div className="h-2.5 overflow-hidden rounded-full bg-ballet-blush" data-id="element-62">
          <div className="h-full w-[65%] rounded-full bg-ballet-pink" data-id="element-63" />
        </div>
        <p className="mt-2 text-right text-xs text-ballet-muted" data-id="element-64">
          65% of spots taken
        </p>
      </div>
    </motion.div>;
}
function TimeBox({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="min-w-[74px] rounded-xl border border-ballet-line bg-ballet-canvas px-3 py-3 sm:min-w-[100px]" data-id="element-65">
      <span className="text-3xl font-bold tabular-nums text-ballet-ink sm:text-4xl" data-id="element-66">
        {value}
      </span>
      <span className="ml-1 text-xs font-semibold text-ballet-rose" data-id="element-67">
        {label}
      </span>
    </div>;
}